import React from 'react'
import RolesForm from './RolesForm'

const NewRolePage = () => {
  return (
    <>
     <RolesForm formType='create' currentRoleId={null} ></RolesForm>
    </>
  )
}

export default NewRolePage
